'use strict';
import adminModule from './admin';
import genericModule from './generic';
import jcwModule from './jcw';
import ugModule from './ug';
import ugSewerModule from './ug_sewer';
import lovelandModule from './loveland';
import durhamModule from './durham';
import calendarModule from './calendar';

const MODULE_NAME = 'daupler.entities';

var app = angular.module(MODULE_NAME, [
	adminModule,
	genericModule,
	jcwModule,
	ugModule,
	ugSewerModule,
	lovelandModule,
	durhamModule,
	calendarModule,
]);

export default MODULE_NAME;
